import { kebabCase } from 'change-case'
import _ from 'lodash'

import { TooltipProps, TransElement } from './types'

export const prepareCypressKey = (content: TooltipProps['content']): string => {
  let text: string | undefined

  if (_.isString(content)) {
    text = content
  } else if (_.isArray(content)) {
    text = content[0]
  } else {
    const { i18nKey, t }: TransElement['props'] = content.props

    if (_.isString(i18nKey) && t) {
      text = t(i18nKey)
    }
  }

  if (!text) {
    throw new Error('Tooltip: cannot extract text from content')
  }

  return kebabCase(text.slice(0, 10).toLocaleLowerCase())
}
